export default "__VITE_ASSET__BFlxNw78__"